import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M54.03 1.22021C63.81 2.79021 75.16 11.3902 76.72 29.0002C78.28 46.6102 74.76 65.0002 76.33 81.0402C77.89 97.0802 79.0699 119.77 79.0699 119.77H1.20996C1.20996 119.77 2.37995 97.0802 3.94995 81.0402C5.51995 65.0002 1.99006 46.6102 3.56006 29.0002C5.13006 11.3902 16.47 2.79021 26.25 1.22021"
        fill={fill}
      />
      <path
        d="M54.03 1.22021C63.81 2.79021 75.16 11.3902 76.72 29.0002C78.28 46.6102 74.76 65.0002 76.33 81.0402C77.89 97.0802 79.0699 119.77 79.0699 119.77H1.20996C1.20996 119.77 2.37995 97.0802 3.94995 81.0402C5.51995 65.0002 1.99006 46.6102 3.56006 29.0002C5.13006 11.3902 16.47 2.79021 26.25 1.22021"
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M14.1501 56.9502C14.1501 56.9502 16.4301 87.7202 13.8701 111.65"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M19 56.6702C19 56.6702 21.28 87.4402 18.72 111.37"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.28 55.8103C21.28 55.8103 23.56 86.5803 21 110.51"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M59.1699 63.5002C59.1699 63.5002 60.0198 95.4102 61.4498 108.8"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M66.01 61.2202C66.01 61.2202 66.86 93.1302 68.29 106.52"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
